import { createLucideIcon } from "lucide-react";

export const SidebarCollapse = createLucideIcon(
    "SidebarCollapse",
    [
        [
            "path",
            {
                d: "M13.4059 13.4059C12.4784 14.3334 10.9856 14.3334 8.00004 14.3334C5.01448 14.3334 3.5217 14.3334 2.5942 13.4059C1.66671 12.4784 1.66671 10.9856 1.66671 8.00004C1.66671 5.01448 1.66671 3.5217 2.5942 2.5942C3.5217 1.66671 5.01448 1.66671 8.00004 1.66671C10.9856 1.66671 12.4784 1.66671 13.4059 2.5942C14.3334 3.5217 14.3334 5.01448 14.3334 8.00004C14.3334 10.9856 14.3334 12.4784 13.4059 13.4059Z",
                key: "ko8tsd",
            },
        ],
        [
            "path",
            {
                d: "M6 14.3334L6 1.66671",
                key: "il7ti0",
            },
        ],
    ],
);
